import { Space, Tag } from 'antd';
import styled from 'styled-components';

export const FilterTag = styled(Tag)`
  .ant-tag-close-icon {
    vertical-align: middle;
    margin-left: 5px;
  }
`;

export const FiltersSpace = styled(Space)`
  margin: 0px 0 20px;
`;
